var React = require('react');

function FlagEsCt (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M256-1H0v173h256V-1z","fill":"#FCDD09","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 18.335h256v19.19H0v-19.19zm256 57.57H0v-19.19h256v19.19zM0 95.095h256v19.19H0v-19.19zm0 38.38h256v19.19H0v-19.19z","fill":"#DA121A","key":1}),React.createElement("defs",{"key":2},React.createElement("clipPath",{"id":"clip0"},React.createElement("path",{"d":"M0 0h256v172H0V0z","fill":"#fff"})))]);
}

FlagEsCt.defaultProps = {"fill":"none","viewBox":"0 0 256 172"};

module.exports = FlagEsCt;

FlagEsCt.default = FlagEsCt;
